import React, { memo, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import Lobby from 'modules/Lobby';
import Modals from 'modules/Modals';
import { EffectTypes } from 'services/Effects';
import type { Normalized, Offer, OfferTile as OfferTileType } from 'lib/LobbyEntities';
import withLazyStyle from 'components/LazyStyle';
import OfferBanner from 'components/OfferBanner';
import style from './offerTile.css?lazy';

interface OfferTileProps {
  entity: OfferTileType;
}

const OfferTile = ({ entity: offerTile }: OfferTileProps) => {
  const dispatch = useAppDispatch();
  const { offer: offerRef } = offerTile;
  const offer = useAppSelector((state) =>
    Lobby.selectors.getEntityByKey(state, offerRef.__access)
  ) as Normalized<Offer> | null;

  const openOfferModal = useCallback(() => {
    dispatch(
      Modals.actions.open('rewardOffer', {
        rewardOfferData: {
          ...offer,
          // TODO: Remove when rewardOffer modal is updated
          ref: offer?.refName,
          cta: offer?.ctaURL,
          heading: offer?.subtitle,
          imageUrl: offer?.modalImageURL,
          termsAndConditions: offer?.terms
        },
        modalParams: {
          source: EffectTypes.OfferClickedSourceType.Lobby,
          ref: offer?.refName
        }
      })
    );
  }, [dispatch, offer]);

  if (!offer) {
    return null;
  }

  return (
    <div className="dynamicLobby__offerTile">
      <OfferBanner
        offer={offer}
        source={EffectTypes.OfferClickedSourceType.Lobby}
        openModal={openOfferModal}
      />
    </div>
  );
};

export default memo(withLazyStyle(style)(OfferTile));
